import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import PublicNav from '../components/PublicNav';
import Footer from '../components/Footer';
import { Calendar, Tag, Eye } from 'lucide-react';

function formatDate(iso) {
  if (!iso) return '';
  try { return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }); }
  catch { return ''; }
}

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/api/marketing/blog?limit=50');
        setPosts(data.posts || []);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <PublicNav />

      <section className="max-w-6xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <span className="inline-block text-[10px] font-bold px-3 py-1 rounded-full bg-[#D4A843]/15 text-[#D4A843] uppercase tracking-wider mb-4">Blog</span>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Practical security for real operators.</h1>
          <p className="text-gray-400 max-w-xl mx-auto">No vendor fluff. Just the stuff you need to know to keep your business running.</p>
        </div>

        {loading ? (
          <p className="text-center text-sm text-gray-500">Loading…</p>
        ) : posts.length === 0 ? (
          <p className="text-center text-sm text-gray-500">No posts yet. Check back soon.</p>
        ) : (
          <div className="grid md:grid-cols-3 gap-6">
            {posts.map((p) => (
              <Link key={p.id} to={`/blog/${p.slug}`} className="group bg-[#111] border border-gray-800 rounded-2xl overflow-hidden hover:border-[#D4A843]/40 transition-colors flex flex-col" data-testid={`blog-card-${p.slug}`}>
                {p.cover_image_url ? (
                  <div className="h-44 overflow-hidden bg-[#0A0A0A]"><img src={p.cover_image_url} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
                ) : (
                  <div className="h-44 bg-gradient-to-br from-[#D4A843]/20 to-[#7C3AED]/20" />
                )}
                <div className="p-5 flex-1 flex flex-col">
                  <h2 className="text-lg font-bold leading-tight group-hover:text-[#D4A843] transition-colors">{p.title}</h2>
                  <p className="text-xs text-gray-400 mt-2 flex-1">{p.excerpt}</p>
                  <div className="flex items-center gap-3 mt-4 text-[10px] text-gray-500">
                    <span className="flex items-center gap-1"><Calendar className="w-3 h-3" />{formatDate(p.published_at)}</span>
                    {p.views > 0 && <span className="flex items-center gap-1"><Eye className="w-3 h-3" />{p.views}</span>}
                    {p.tags?.[0] && <span className="flex items-center gap-1 text-[#D4A843]"><Tag className="w-3 h-3" />{p.tags[0]}</span>}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
}
